import React from "react";

/**
 * PageHero: reusable dark hero used on inner pages.
 */
export default function PageHero({ eyebrow, title, subtitle, image }) {
  return (
    <section
      className="relative bg-brand-ink text-white overflow-hidden"
      data-testid="page-hero"
    >
      <div
        className="absolute inset-0 opacity-40"
        style={{
          backgroundImage: `linear-gradient(135deg, rgba(0,107,45,0.7), rgba(10,10,10,0.85)), url(${image})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      />
      <div className="relative max-w-[1400px] mx-auto px-6 lg:px-12 py-24 md:py-32">
        <p className="section-tag text-brand-orange" data-testid="page-hero-eyebrow">{eyebrow}</p>
        <h1
          className="font-heading text-5xl md:text-7xl lg:text-8xl leading-[0.9] tracking-tightest mt-6 max-w-5xl"
          data-testid="page-hero-title"
        >
          {title}
        </h1>
        {subtitle && (
          <p className="font-body text-base md:text-lg text-zinc-300 mt-8 max-w-2xl leading-relaxed">
            {subtitle}
          </p>
        )}
      </div>
      <div className="absolute bottom-0 left-0 right-0 h-1 bg-brand-orange" />
    </section>
  );
}
